import React from "react";
import { useTranslation } from "react-i18next";

import { Tab, Tabs } from "@material-ui/core";
import { ContactType } from '@cargoticcom/model'

import ContactProfileView from "../../ContactProfileView";

const ContactProfileBodyNavigation = ({ view, onViewChange, contact }) => {
  const { t } = useTranslation();
  const contactType = contact?.type

  const handleTabChange = (_, value) => onViewChange(value);

  return (
    <Tabs
      indicatorColor="primary"
      value={view}
      onChange={handleTabChange}
    >
      <Tab
        label={t("webapp:common.title.billing")}
        value={ContactProfileView.CONTACT_BILLING_OVERVIEW}
      />
      <Tab
        label={t("webapp:common.title.overview")}
        value={ContactProfileView.CONTACT_OVERVIEW}
      />
      <Tab
        label={t("webapp:common.title.employees")}
        value={ContactProfileView.CONTACT_EMPLOYEE_OVERVIEW}
      />
      {contact.isSubcontractor && (
      <Tab
        label={t("webapp:common.title.vehicles")}
        value={ContactProfileView.CONTACT_VEHICLES_OVERVIEW}
      />
      )}
    </Tabs>
  );
};

export default ContactProfileBodyNavigation;
